import { render, staticRenderFns } from "./popup_payment_methods.vue?vue&type=template&id=97ef70d6&scoped=true&"
import script from "./popup_payment_methods.vue?vue&type=script&lang=js&"
export * from "./popup_payment_methods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ef70d6",
  null
  
)

export default component.exports